module.exports = __webpack_public_path__ + "static/media/driver2_mobile.3c9280bf.png";